import { Component, OnInit, Input } from "@angular/core";
import { SurveysService } from "../../../../services/surveys.service";

interface MailingSettings {
  from: {
    name: string;
    email: string;
  };
}

@Component({
  selector: "app-survey-mailingssettings",
  templateUrl: "./survey-mailingssettings.component.html",
  styleUrls: ["./survey-mailingssettings.component.css"],
})
export class SurveyMailingssettingsComponent implements OnInit {
  @Input() survey: any;

  initialized: boolean = false;
  mailingSettings: MailingSettings = {
    from: {
      name: "",
      email: "",
    },
  };

  constructor(private surveysService: SurveysService) {}

  ngOnInit(): void {
    this.InitializeSurveyMailingsSettings();
  }

  InitializeSurveyMailingsSettings() {
    this.surveysService
      .getSurveyMailingsSettings(this.survey.id)
      .valueChanges()
      .subscribe((settings) => {
        if (settings) {
          this.mailingSettings = {
            from: {
              name: settings.from?.name || "",
              email: settings.from?.email || "",
            },
          };
        }
        this.initialized = true;
      });
  }

  onSaveMailingSettings() {
    // Check if all fields are empty
    const allFieldsEmpty =
      !this.mailingSettings.from.name.trim() &&
      !this.mailingSettings.from.email.trim();

    if (allFieldsEmpty) {
      // Delete the entry if all fields are empty
      this.onDeleteMailingSettings();
      return;
    }

    // Otherwise, save as normal
    this.surveysService
      .updateSurveyMailingsSettings(this.survey.id, this.mailingSettings)
      .then(() => {
        alert("Mailing settings saved successfully");
      })
      .catch((error) => {
        alert("Error saving mailing settings: " + error);
      });
  }

  onDeleteMailingSettings() {
    if (
      confirm("Are you sure you want to delete the mailing settings?") == true
    ) {
      this.surveysService
        .deleteSurveyMailingsSettings(this.survey.id)
        .then(() => {
          alert("Mailing settings deleted successfully");
          // Reset the form to empty state
          this.mailingSettings = {
            from: { name: "", email: "" },
          };
        })
        .catch((error) => {
          alert("Error deleting mailing settings: " + error);
        });
    }
  }
}
